import css from '@styled-system/css';
import styled from 'styled-components';
import { ThemeStyles } from '@honda-canada/design-system-react';
import variant from '@styled-system/variant';
import { PSP_SITE_NAME } from '../../utils/constants';

export const themeStyles = new ThemeStyles();

export const Image = styled.img`
  width: 100%;
  height: 100%;
  transition: all 0.5s ease-in-out;
  object-fit: cover;
  z-index: 10;
  cursor: ${({ is360Mode }) => (is360Mode ? 'grab' : 'pointer')};
  user-select: none;
`;

export const IconContainerAlt = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  align-items: center;
  z-index: 2;
  justify-content: center;
  cursor: grab;
  transform: translate(-50%, -50%);
`;
export const IconContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  align-items: center;
  z-index: 2;
  justify-content: center;
`;

export const IconButton = styled.button`
  outline: none;
  background-color: transparent;
  border: none;
  width: fit-content;
  height: fit-content;
  cursor: pointer;
`;

themeStyles.addBaseStyles('ImageContainer')(({ height, threeSixtyImageHeight }) =>
  css({
    touchAction: 'none',
    position: 'relative',
    width: '100%',
    maxHeight: `${height}px`,
    height: threeSixtyImageHeight || '77.5vh',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    '@media only screen and (min-width: 1074px)': {
      maxHeight: '100%',
    },
  }),
);

themeStyles.addBaseStyles('AccessoryOverlayImage')(({ isVisible, is360Mode, height }) =>
  css({
    display: isVisible ? 'block' : 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    maxHeight: `${height}px`,
    cursor: is360Mode ? 'grab' : 'pointer',
  }),
);

themeStyles.addBaseStyles('StyledImage')(() =>
  variant({
    variants: {
      [PSP_SITE_NAME]: {
        display: 'block',
        height: '100%',
        width: '60%',
        margin: 'auto',
      },
    },
  }),
);

// Modify the Pannellum control to look like design
export const PannellumContainer = styled.div`
  ${css({
    width: '100%',
    height: '100%',
    zIndex: 1,
    // Only way to hide the loader from pannellum
    '& .pnlm-load-box': {
      display: 'none !important',
    },
    '& .pnlm-controls-container': {
      bottom: '24px',
      left: ['12px', '24px'],
      top: 'auto',
      '& .pnlm-zoom-controls': {
        background: 'transparent',
        gap: '10px',
        height: ['76px', '100px'],
        width: ['28px', '40px'],
        border: 'none',
        '& div': {
          width: ['28px', '40px'],
          height: ['28px', '40px'],
          borderRadius: '50%',
          border: '2px solid white',
          background: 'transparent',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: ['16px', '24px'],
        },
        '& .pnlm-zoom-in:after': {
          content: '"+"',
        },
        '& .pnlm-zoom-out:after': {
          content: '"-"',
        },
      },
    },
  })}
`;

export const ThreeSixtyInViewContainer = styled.div`
  ${css({
    position: 'absolute',
    top: ['12px', '24px'],
    left: ['12px', '24px'],
  })}
`;
